import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	getMdjYStastic_({ commit, state }) {
		const { searchParams } = state;
		const getMData = function (data, isRate){
			let backData = [];
			for(let i = 1; i <= 12; i++){
				let key = i < 10 ? 'mm0' + i : 'mm' + i;
				let cuData = data[key];
				if(isRate){
					cuData = cuData.replace('%', '');
					backData.push(parseFloat(cuData));
				}else{
					backData.push(parseInt(cuData));
				}
				
			}
			return backData;
		};
		return api
			.getMdjYStastic({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					let tbData = data.body.tbData;
					commit(types.DEFAULT_ASSIGN, {
						key: 'mdjTbList',
						value: data.body.tbData || []
					});

					let ngRateData = tbData[6];
		
					let barData =  [
						{
							"idxScn": "年度不良实绩",
							"bfYy": ngRateData.bfYear,
							"bfCnt": ngRateData.bfRslt.replace("%", ""),
							"cuYy": ngRateData.cuYear,
							"cuCnt": ngRateData.cuRslt.replace("%", ""),
						}		
					];

					commit(types.DEFAULT_ASSIGN, {
						key: 'graphBarStackChartInfo',
						value: barData
					});

					let bpNgData = tbData[3];
					let zzNgData = tbData[4];
					let otherNgData = tbData[5];

					
					let barLineData =  [
						{
							type: 'bar',
							itemNm: bpNgData.itemNm,
							data: getMData(bpNgData, false)
						},	
						{
							type: 'bar',
							itemNm: zzNgData.itemNm,
							data: getMData(zzNgData, false)
						},	
						{
							type: 'bar',
							itemNm: otherNgData.itemNm,
							data: getMData(otherNgData, false)
						},	
						{
							type: 'line',
							itemNm: ngRateData.itemNm,
							data: getMData(ngRateData, true)
						},	
					];

					commit(types.DEFAULT_ASSIGN, {
						key: 'graphLineChartInfo',
						value: barLineData
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'isLoading',
						value: true
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
